module.exports = __webpack_public_path__ + "media/assets/certification_page/mb_logo-77e695dba437cee85d7a2b1e322c7aa7d38f1d5b9accb552ba93501ef45be797.svg";